import React from "react";
import SwNoDataBg from "./img/No-data-bg.svg";

const SwNoData = ({
  message = "No Data available",
  image = SwNoDataBg,
  className = "",
}) => {
  return (
    <div className={`d-flex justify-content-center align-items-center ${className}`}>
      <div className="SwNoDataContainer text-center">
        <img src={image} className="SwLoaderImg" alt="No data" />
        <p className="mt-2">{message}</p>
      </div>
    </div>
  );
};

export default SwNoData;
